import apiClient from './api_client_requests';

export default async (payload) => {
    let result = await apiClient.apiMethod({
        method: 'GetPromotionDetail',
        args: { ...payload },
    });

    const response = {
        promotionData: {},
        error: null,
    };

    if (result?.response?.code > 299) {
        response.error = response.message;
    } else {
        response.promotionData = result;
    }

    return response;
};
